import React from 'react';

import { useState, useEffect } from 'react';

import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Collapse from '@mui/material/Collapse';

import MyDatePicker from 'components/Shared/MyDatePicker';


import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { AdresseDestinations } from 'constants.js';


import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';
import DepotGestionSelect from 'components/Shared/DepotGestionSelect';
import AdresseForm from '../../../Shared/AdresseForm';


import localStorageHelper from 'utils/localStorageHelper';



const commentairePlaceholder = "Veuillez détailler votre demande : référence fournisseur, prix d'achat, quantité, commentaire….";


function DemandePieceDetacheeFournisseurDialogContent({ onChange, action }) {

    const [fournisseur, setFournisseur] = useState(null);
    const [contactFournisseur, setContactFournisseur] = useState('');

    const [modeAdresse, setModeAdresse] = useState(99);
    const [codeDepot, setCodeDepot] = useState(localStorageHelper.getCodeDepot({ magasin: true }));
    const [adresse, setAdresse] = useState(null);
    const [adresseStr, setAdresseStr] = useState('');

    const [reference, setReference] = useState('');
    const [quantite, setQuantite] = useState('');
    const [prixAchat, setPrixAchat] = useState('');
    const [commentaire, setCommentaire] = useState('');
    const [dateLivraison, setDateLivraison] = useState(null);

    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (fournisseur === null) {
                return null;
            }
            if (modeAdresse === 3 && adresseStr === '') { // Autre adresse
                return null;
            }

            if (modeAdresse === 99 && codeDepot === '') { // Magasin
                return null;
            }

            if (reference === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.Fournisseur,
                        type: ReclamationActionDetailType.FournisseurId,
                        libelle: "Fournisseur",
                        position: 0,
                        valeurString: `${fournisseur.code} - ${fournisseur.nom}`,
                        valeurInteger: fournisseur.id
                    }]
            };

            if (contactFournisseur) {
                actionData.details.push(
                    {
                        code: ReclamationActionDetailCodes.ContactFournisseur,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Contact fournisseur",
                        position: actionData.details.length,
                        valeurString: contactFournisseur
                    }
                );
            }

            if (modeAdresse === 99) {

                actionData.details.push(
                    {
                        code: ReclamationActionDetailCodes.Adresse,
                        type: ReclamationActionDetailType.CodeDepot,
                        libelle: "Adresse de livraison",
                        position: actionData.details.length,
                        valeurString: codeDepot
                    }
                );
            }
            else if (modeAdresse === 3) {

                    actionData.details.push(
                        {
                            code: ReclamationActionDetailCodes.Adresse,
                            type: ReclamationActionDetailType.Texte,
                            libelle: "Adresse de livraison",
                            position: actionData.details.length,
                            valeurString: adresseStr
                        }
                    );
                }
            else {

                let adresse = AdresseDestinations.find(x => x.id === modeAdresse);

                actionData.details.push(
                    {
                        code: ReclamationActionDetailCodes.Adresse,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Adresse de livraison",
                        position: actionData.details.length,
                        valeurString: adresse.nom
                    }
                );

            }






            actionData.details.push(
                {
                    code: ReclamationActionDetailCodes.Reference,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Référence fournisseur demandée",
                    position: actionData.details.length,
                    valeurString: reference
                }
            );


            
            actionData.details.push(
                {
                    code: ReclamationActionDetailCodes.Quantite,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Quantité",
                    position: actionData.details.length,
                    valeurString: quantite
                }
            );

            
            actionData.details.push(
            {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Flottant,
                libelle: "Prix d'achat",
                position: actionData.details.length,
                valeurFloat: prixAchat
            }
            );

            
            actionData.details.push(
                {
                    code: ReclamationActionDetailCodes.Commentaire,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Commentaire",
                    position: actionData.details.length,
                    valeurString: commentaire
                }
            );

            if (dateLivraison !== null) {
                actionData.details.push(
                    {
                        code: ReclamationActionDetailCodes.DateRelivraison,
                        type: ReclamationActionDetailType.Date,
                        libelle: "Date livraison demandée",
                        position: actionData.details.length,
                        valeurDate: dateLivraison.toDateString()
                    }
                );
            }

            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, fournisseur, contactFournisseur, modeAdresse, codeDepot, adresse, adresseStr, reference, quantite, prixAchat, commentaire, dateLivraison]);



    return (
        <DialogContent>

            <Stack mt={1} spacing={1}>
                <FournisseurGestionAutocomplete
                    onChange={setFournisseur}
                    withConditionsSAVGenerales={false}
                    required
                    size={"medium"}
                    autoFocus
                />

                <TextField
                    value={contactFournisseur}
                    onChange={e => setContactFournisseur(e.target.value)}
                    label={"Contact fournisseur"}
                    multiline
                />

                <TextField
                    select
                    label={"Adresse de livraison"}
                    value={modeAdresse}
                    onChange={e => setModeAdresse(e.target.value)}
                >

                    {AdresseDestinations.map(adresse => (

                        <MenuItem key={adresse.id} value={adresse.id}>{adresse.nom}</MenuItem>

                    ))}

                    <MenuItem value={`99`}>Magasin</MenuItem>

                </TextField>


                <Collapse
                    in={modeAdresse === 99}
                    timeout={1000}
                >
                    <DepotGestionSelect value={codeDepot} onChange={(e, code) => setCodeDepot(code)} valueIsCode magasinsSeulement isRequired={false} autoFocus={false} label="Sélectionner un magasin :" modeTri={1} />
                </Collapse>



                <Collapse
                    in={modeAdresse === 3}
                    timeout={1000}
                >
                    <AdresseForm
                        label={"Veuillez renseigner l'adresse de livraison"}
                        adresse={adresse}
                        onChange={(addr, addrStr) => { setAdresse(addr); setAdresseStr(addrStr); }}
                    />
                </Collapse>



                <TextField
                    value={reference}
                    onChange={e => setReference(e.target.value)}
                    label={"Référence fournisseur demandée"}
                    required
                />


                <TextField
                    value={quantite}
                    onChange={e => setQuantite(e.target.value)}
                    label={"Quantité"}
                />




                <TextField
                    value={prixAchat}
                    onChange={e => setPrixAchat(e.target.value)}
                    label={"Prix d'achat"}
                    type={"number"}
                    inputProps={{ min: 0 }}
                />



                <TextField
                    value={commentaire}
                    onChange={e => setCommentaire(e.target.value)}
                    label={"Commentaire"}
                    multiline
                    placeholder={commentairePlaceholder}
                />



                <MyDatePicker
                    label="Date de livraison demandée"
                    value={dateLivraison}
                    onChange={value => setDateLivraison(value)}
                    fullWidth
                    disableFuture={false}
                    disablePast={true}
                    disableSunday={true}
                />

            </Stack>


        </DialogContent>
    );

}


export default DemandePieceDetacheeFournisseurDialogContent;